import { Box, Flex, Text } from '@chakra-ui/react';

import { ExternalLink } from '$components/chakra/external-link';
import { DefaultLayout } from '$components/layout/default-layout';
import { Comments } from '$components/ui/comments';
import { Markdown } from '$components/ui/markdown';
import { readingTime } from '$utils/reading-time';

interface Post {
  slug: string;
  title: string;
  content: string;
  createdAt: string;
  tabcoins: number;
}

export interface PostTemplateProps {
  post: Post;
}

export function PostTemplate({ post }: PostTemplateProps) {
  const minutes = readingTime(post.content);
  const tabnewsHref = `https://www.tabnews.com.br/silvanomarques/${post.slug}`;

  return (
    <DefaultLayout>
      <Box as="article" pt={{ base: '16px', md: '32px' }}>
        <Flex
          gap="14px"
          align="center"
          mb="20px"
          fontFamily="mono"
          fontSize="11px"
          letterSpacing="0.12em"
          textTransform="uppercase"
          color="text.faint"
          wrap="wrap"
        >
          <Text>{post.createdAt}</Text>
          <Box w="3px" h="3px" bg="text.faint" borderRadius="full" />
          <Text>{minutes} min de leitura</Text>
          <Box w="3px" h="3px" bg="text.faint" borderRadius="full" />
          <ExternalLink
            href={tabnewsHref}
            underline={false}
            fontSize="11px"
            letterSpacing="0.12em"
          >
            Original no TabNews ↗
          </ExternalLink>
        </Flex>

        <Box
          as="h1"
          fontFamily="display"
          fontSize={{ base: '40px', md: '56px' }}
          lineHeight="1.05"
          letterSpacing="-0.02em"
          color="text.primary"
          mb="40px"
        >
          {post.title}
        </Box>

        <Markdown>{post.content}</Markdown>

        <Box mt="80px" pt="40px" borderTopWidth="1px" borderColor="line.subtle">
          <Text
            fontFamily="mono"
            fontSize="11px"
            letterSpacing="0.16em"
            textTransform="uppercase"
            color="text.faint"
            mb="20px"
          >
            Discussion
          </Text>
          <Comments />
        </Box>
      </Box>
    </DefaultLayout>
  );
}
